import React from "react";

const LIVELLI = {
  0: { label:"Non specificato", col:"#9ca3af" },
  1: { label:"Inesperto",       col:"#6b7280" },
  2: { label:"Poco esperto",    col:"#d97706" },
  3: { label:"Autonomo",        col:"#2563eb" },
  4: { label:"Esperto",         col:"#7c3aed" },
  5: { label:"Molto esperto",   col:"#059669" },
};

/**
 * SquadraEditor
 * squadra: [{ livello: number }]  — un elemento per ogni operaio
 * onChange: (nuovaSquadra) => void
 * compact: bool
 */
export default function SquadraEditor({ squadra=[], onChange, compact=false }) {

  const totale = squadra.length;

  // Cambia numero totale operai
  const setTotale = (n) => {
    const num = Math.max(1, Math.min(50, parseInt(n)||1));
    if(num > totale){
      // Aggiungi operai con livello 0 (non specificato)
      onChange([...squadra, ...Array.from({length:num-totale},()=>({livello:0}))]);
    } else {
      onChange(squadra.slice(0, num));
    }
  };

  // Cambia livello di un singolo operaio
  const setLivello = (idx, livello) => {
    const nuova = squadra.map((op,i)=>i===idx?{...op,livello}:op);
    onChange(nuova);
  };

  const inp = {
    border:"1px solid #e5e7eb", borderRadius:7,
    fontFamily:"'Inter',sans-serif", fontSize:12, outline:"none",
    padding: compact?"5px 8px":"7px 10px",
    background:"#fff",
  };

  return (
    <div>
      {/* Numero operai */}
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
        <label style={{fontSize:11,fontWeight:700,color:"#374151",flexShrink:0}}>
          Numero operai necessari
        </label>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <button onClick={()=>setTotale(totale-1)}
            style={{width:28,height:28,border:"1px solid #e5e7eb",borderRadius:6,background:"#fff",cursor:"pointer",fontSize:16,color:"#374151",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700}}>−</button>
          <input type="number" min={1} max={50} value={totale}
            onChange={e=>setTotale(e.target.value)}
            onFocus={e=>e.target.select()}
            style={{...inp,width:52,textAlign:"center",fontSize:15,fontWeight:800,color:"#7c3aed"}}/>
          <button onClick={()=>setTotale(totale+1)}
            style={{width:28,height:28,border:"1px solid #e5e7eb",borderRadius:6,background:"#fff",cursor:"pointer",fontSize:16,color:"#374151",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700}}>+</button>
        </div>
      </div>

      {/* Un menu a tendina per ogni operaio */}
      {totale>0 && (
        <div>
          <div style={{fontSize:11,color:"#9ca3af",marginBottom:6}}>
            Seleziona il livello professionalità per ogni operaio:
          </div>
          <div style={{display:"grid",gridTemplateColumns:compact?"repeat(2,minmax(0,1fr))":"repeat(3,minmax(0,1fr))",gap:8}}>
            {squadra.map((op,idx)=>{
              const li = LIVELLI[op.livello]||LIVELLI[0];
              return (
                <div key={idx} style={{display:"flex",flexDirection:"column",gap:3,minWidth:0}}>
                  <label style={{fontSize:10,color:"#9ca3af",fontWeight:600}}>
                    Operaio {idx+1}
                  </label>
                  <select value={op.livello} onChange={e=>setLivello(idx,parseInt(e.target.value))}
                    style={{...inp,width:"100%",minWidth:0,color:li.col,fontWeight:700,borderColor:li.col+"44"}}>
                    <option value={0}>— Non specificato —</option>
                    <option value={1}>1 — Inesperto</option>
                    <option value={2}>2 — Poco esperto</option>
                    <option value={3}>3 — Autonomo</option>
                    <option value={4}>4 — Esperto</option>
                    <option value={5}>5 — Molto esperto</option>
                  </select>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Riepilogo */}
      {totale>0 && (
        <div style={{marginTop:10,padding:"6px 10px",background:"#f0f9ff",border:"1px solid #bae6fd",borderRadius:7,fontSize:11,color:"#0369a1"}}>
          {riepilogoSquadra(squadra)}
        </div>
      )}
    </div>
  );
}

// ── Helpers esportati ─────────────────────────────────────────

function riepilogoSquadra(squadra) {
  if(!squadra||squadra.length===0) return "Nessun operaio definito";
  const LABEL = {0:"N/D",1:"Inesperto",2:"Poco esp.",3:"Autonomo",4:"Esperto",5:"Molto esp."};
  // Raggruppa per livello
  const gruppi = {};
  squadra.forEach(op=>{
    const k = op.livello||0;
    gruppi[k] = (gruppi[k]||0)+1;
  });
  const parti = Object.entries(gruppi)
    .sort((a,b)=>parseInt(b[0])-parseInt(a[0]))
    .map(([lv,qty])=>`${qty}× ${LABEL[lv]||"Liv."+lv}`);
  return `Squadra: ${parti.join(" · ")} — Totale ${squadra.length} persone`;
}

export function squadraToString(squadra=[]) {
  if(!squadra||squadra.length===0) return "—";
  const LABEL = {0:"N/D",1:"Inesperto",2:"Poco esp.",3:"Autonomo",4:"Esperto",5:"Molto esp."};
  const gruppi = {};
  squadra.forEach(op=>{ const k=op.livello||0; gruppi[k]=(gruppi[k]||0)+1; });
  return Object.entries(gruppi).sort((a,b)=>b[0]-a[0]).map(([lv,qty])=>`${qty}× ${LABEL[lv]}`).join(" · ");
}

export function squadraTotale(squadra=[]) {
  return (squadra||[]).length;
}

export function normalizzaSquadra(project) {
  // Se ha già squadra nel formato nuovo
  if(project?.squadra && Array.isArray(project.squadra) && project.squadra.length>0){
    // Gestisce sia formato nuovo [{livello}] che vecchio [{livello,quantita}]
    const squadra = [];
    project.squadra.forEach(r=>{
      if(r.quantita){
        // Vecchio formato — espandi
        for(let i=0;i<(parseInt(r.quantita)||1);i++) squadra.push({livello:r.livello||0});
      } else {
        squadra.push({livello:r.livello||0});
      }
    });
    return squadra;
  }
  // Retrocompatibilità con operaiNecessari + livelloMin
  if(project?.operaiNecessari>0){
    return Array.from({length:parseInt(project.operaiNecessari)||1},()=>({livello:parseInt(project.livelloMin)||0}));
  }
  return [];
}
